import { CircularProgress } from '@mui/material';
import { useStripeProducts } from 'services/hooks';
import ReleasesPremiumPreview from 'assets/images/releases_premium_preview.jpg';
import {
  StyledDistributionInfo,
  StyledLoadingContainer,
  StyledReleaseDummyImage,
} from './styled';
import { UpgradeButton } from './components';

export const UpsellInfo = () => {
  const { isFetching: areStripeProductsFetching } = useStripeProducts();

  if (areStripeProductsFetching) {
    return (
      <StyledLoadingContainer>
        <CircularProgress color="primary" size="4rem" />
      </StyledLoadingContainer>
    );
  }

  return (
    <>
      <StyledDistributionInfo customFooter={<UpgradeButton />} />
      <StyledReleaseDummyImage
        src={ReleasesPremiumPreview}
        alt="Image of our distribution service."
      />
    </>
  );
};

export default UpsellInfo;
